
import apis from "../http/api";

const commonApi = {
   
};


//use_type 0: '未知', 1: '登录', 2: '退出登录', 3: '使用app反馈功能', 4: '操作审核', 5: '操作反馈', 6: '辅助功能-查询短信验证码', 7: 'Co钻扣除', 8: '批量发币' , 9: '即刻查询用户', 10: '即刻重置用户'
commonApi.TypeLogin = 1;
commonApi.TypeLogout = 2;
commonApi.TypeMenuAppFeedback = 3;
commonApi.TypeOperationReport = 4;
commonApi.TypeOperationFeedback = 5;
commonApi.TypeOperationToolCaptcha = 6;
commonApi.TypeOperationToolRemoveJewelCount = 7;
commonApi.TypeOperationToolCurrencySend = 8;
commonApi.TypeOperationToolJKUserInfoSearch = 9;
commonApi.TypeOperationToolJKUserInfoReset = 10;
commonApi.recordCreate = (type,content) => {

    let post_data = {
        use_type: type
    }
    switch(type){
        case commonApi.TypeMenuAppFeedback:
        case commonApi.TypeOperationReport:
        case commonApi.TypeOperationFeedback:
        case commonApi.TypeOperationToolCaptcha:
        case commonApi.TypeOperationToolRemoveJewelCount:
        case commonApi.TypeOperationToolCurrencySend:
        case commonApi.TypeOperationToolJKUserInfoSearch:
        case commonApi.TypeOperationToolJKUserInfoReset:
            post_data['use_content'] = JSON.stringify(content)
            break
    }
    // console.log(JSON.stringify(post_data))
    apis.user_use_record_create(post_data).then(res => {
      const { data, errCode, msg } = res;
      if (errCode === 0) {
       
      } else {
        // alert(msg)
      }
    }).catch(err => {
      // alert('统计接口异常')
    })
    return ""
}

// 入口Tab点击
commonApi.recordFromMenu = (title,url) => {
    switch(url){
        case '/report':
            let post_data = {
                content:title,
                url:url
            }
            commonApi.recordCreate(commonApi.TypeMenuAppFeedback, post_data)
            break
    }
    return ""
}

// App反馈-意见反馈
commonApi.recordFromOperationFeedback = (type,list,status,id,content) => {
    switch(type){
        case 0:
        case 1:
        case 2:
            // 处理、忽略、待处理、发放奖励、切换类型
            list.forEach(item => {
               if(item.value == status){
                   let use_content = {
                     content: content+item.label,
                     id: id,
                   };
                   commonApi.recordCreate(commonApi.TypeOperationFeedback, use_content)
               }
            })
            break
        case 3:
            // 回复
            let use_content = {
                content: content,
                id: id,
            };
            commonApi.recordCreate(commonApi.TypeOperationFeedback, use_content)
            break
    }
    return ""
}

// App反馈-举报审核
commonApi.recordFromOperationReport = (type,list,status,id,content,user_id) => {
    switch(type){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
            // 处理、忽略、封禁用户、修改期限、用户解封、警告通知、禁言、清除用户信息、清除其他信息
            let use_content = {
                content: content,
                id: id,
                user_id:user_id,
            };
            commonApi.recordCreate(commonApi.TypeOperationReport, use_content)
            break
    }
    return ""
}

// 辅助功能-查询短信验证码
commonApi.recordFromOperationToolCaptcha = (type,content) => {
    switch(type){
        case 0:
            // 查询短信验证码
            let use_content = {
                content: content
            };
            commonApi.recordCreate(commonApi.TypeOperationToolCaptcha, use_content)
            break
    }
    return ""
}

// 辅助功能-Co钻扣除
commonApi.recordFromOperationToolRemoveJewelCount = (type,content,invite_code) => {
    switch(type){
        case 0:
            // Co钻扣除
            let use_content = {
                content: content,
                invite_code: invite_code
            };
            commonApi.recordCreate(commonApi.TypeOperationToolRemoveJewelCount, use_content)
            break
    }
    return ""
}

// 辅助功能-批量发币
commonApi.recordFromOperationToolCurrencySend = (type,current_type,count) => {
    switch(type){
        case 0:
            // 批量发币
            let use_content = {
                current_type: current_type,
                count: count
            };
            commonApi.recordCreate(commonApi.TypeOperationToolCurrencySend, use_content)
            break
    }
    return ""
}

// 用户查询功能-即刻用户查询
commonApi.recordFromOperationToolJKUserInfoSearch = (type,invite_code) => {
    switch(type){
        case 0:
            // 即刻用户查询
            let use_content = {
                invite_code:invite_code
            };
            commonApi.recordCreate(commonApi.TypeOperationToolJKUserInfoSearch, use_content)
            break
    }
    return ""
}

// 用户查询功能-重置用户信息
commonApi.recordFromOperationToolJKUserInfoReset = (type,key,user_id,content) => {
    switch(type){
        case 0:
            // 重置用户信息
            let use_content = {
                key: key,
                user_id:user_id,
                content: content
            };
            commonApi.recordCreate(commonApi.TypeOperationToolJKUserInfoReset, use_content)
            break
    }
    return ""
}

export default commonApi